export default __webpack_public_path__ + "locales/pl/ChangeUserStatusDialog.json?hash=751128a903d801162a8448f0a98f4e97";